import { useContext, useEffect, useState } from "react";
import { IoIosCloseCircle } from "react-icons/io";
import { Alert, Button, Card, Col, Form, Image, Modal, Row } from "react-bootstrap"
import { Link, useHistory, useParams } from "react-router-dom"
import { Field, FieldArray, Formik } from "formik"
import * as Yup from 'yup';
import Post from '../../../api/Post'
import Get from '../../../api/Get'
import { 
    ACCOUNT_GET,
    ACCOUNT_SETTING_GET_BY_ID,
    ACCOUNT_SETTING_SAVE,
    ACCOUNT_SETTING_UPDATE,
    FIELDS_GET,
} from "../../../api/Routes";
import { authContext } from "../../../context/AuthContext";
import LoadingList from "../../../loader/LoadingList";
import { withTranslation } from "react-i18next";
import ComponentModalErrorSever from "../../../components/ComponentModalErrorSever";
import { FaPlus, FaTrash } from "react-icons/fa";
import iconRecheck from '../../../img/icons/recheck.svg'
import Put from "../../../api/Put";



function FieldsCuenta({t}){
    const { auth } = useContext(authContext)
    const history = useHistory();
    const {id} = useParams();
    const [loading, setLoading] = useState(false)
    const [account, setAccount] = useState(null)
    const [fieldOpt, setFieldOpt] = useState([])
    const [initialValues, setInitialValues] = useState({
        id:null,
        fieldList: [],
        account: {id: id}
    })  
    const [errorServer, setErrorServer] = useState(null)
    const [showModalServer, setShowModalServer] = useState(false)
    const handleCloseModalServer = () => {
        setShowModalServer(false)
    }
    const [showSuccess, setShowSuccess] = useState(false);
    const handleCloseSuccess = () => setShowSuccess(false);

    useEffect(() => {
        setLoading(true)
        async function getCuenta(){
            try {
                const response = await Get({url: `${ACCOUNT_GET}/${id}`, access_token: auth.data.access_token})
                setAccount(response.data.data)
                setLoading(false)
            } catch (error) {
                setAccount(null)
                setLoading(false)
            }           
        }
        getCuenta();
    }, [])

    useEffect(() => {
        async function getFields(){
            const response = await Get({url: `${ACCOUNT_SETTING_GET_BY_ID}/${id}`, access_token: auth.data.access_token})
            //console.log(response)
            setInitialValues({
                id:response.data.data?.id || null,
                fieldList: response.data.data?.formSettingsDTOList?.map(field=>({id: field.id, 
                    fieldName: {id: field.formFieldName.id}, 
                    visible: field.visible, 
                    required: field.required,
                    account: {id: id}})) || [],
                account: {id: id}
            })
        }
        getFields();
    }, [])
    
    useEffect(() => {
        async function getFieldsOpt(){
            const response = await Get({url: `${FIELDS_GET}/`, access_token: auth.data.access_token})
            setFieldOpt(response.data.data.response)
        }
        getFieldsOpt();
    }, [])

    Yup.addMethod(Yup.array, 'unique', function (message, mapper = a => a) {
        return this.test('unique', message, function (list) {
          return list.length === new Set(list.map(mapper)).size;
        });
      });
    
    const shemaValidate = Yup.object().shape({
        fieldList: Yup.array().of(
            Yup.object().shape({
                fieldName: Yup.object().shape({
                    id: Yup.string().required('Campo requerido'),
                }),
                visible: Yup.boolean().when('required', {
                    is: true,
                    then: Yup.boolean().oneOf([true], 'Campo debe estar visible'),
                    otherwise: Yup.boolean().notRequired()
                })
            })
        )
        .unique('No se puede crear dos campos iguales. Por favor revise su configuración', a => a.fieldName.id),
    });

    return( <>
        { 
            loading ? <LoadingList texto='' /> : <>

            <div className="body">
                <Row className="align-items-center">
                    <Col xs="12" md="8">
                        {account && <h2 className="mb-0 title-top">{`Cuenta ${account?.name}` }</h2>}
                    </Col>
                    <Col xs="12" md="4" className="text-right">
                        <IoIosCloseCircle className="cancel-btn" onClick={e=>history.goBack()}/>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Formik 
                            initialValues={ initialValues }
                            enableReinitialize
                            validationSchema={ shemaValidate }
                            onSubmit={async (values, { setSubmitting, setFieldValue }) => { 
                                try {
                                    let response;
                                    if(values.id){
                                        response = await Put({url: ACCOUNT_SETTING_UPDATE, data: values, header:true, access_token:   auth.data.access_token})
                                    }else{
                                        response = await Post({url: ACCOUNT_SETTING_SAVE, data: values, header:true, access_token:   auth.data.access_token})
                                    }
                                    //console.log(response)
                                    if(response.data.state){
                                        setSubmitting(false) 
                                        setShowSuccess(true)
                                        setTimeout(()=>{
                                            setShowSuccess(false)
                                            history.goBack();
                                        }, 2000)
                                    }
                                } catch (error) {
                                        setSubmitting(false)  
                                        setShowModalServer(true)
                                        if(error.response){
                                            setErrorServer(error.response)
                                        } 
                                }
                            }}
                        >{({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            setFieldValue
                        }) => (
                            <Form onSubmit={handleSubmit}  className='mt-3'>
                                {isSubmitting && <LoadingList texto="Procesando información" />}
                                <Card className="shadow-1 formSection">
                                    <Card.Body>
                                        <Row>
                                            <Col>
                                                <h5>Configurar campos</h5>
                                            </Col>
                                        </Row>
                                        
                                        {
                                           (Object.keys(errors).filter(it=>it==='fieldList').length > 0 && typeof errors.fieldList === 'string') &&
                                            <Row>
                                                <Col>
                                                    <Alert variant="danger" className="p-2">{errors.fieldList}</Alert>
                                                </Col>
                                            </Row>
                                        }
                                        <Row>
                                            <Col xs="12" md="12">
                                                <FieldArray 
                                                    name="fieldList"
                                                    render={arrayHelper=>(
                                                        <div>
                                                            {
                                                                (values.fieldList && values.fieldList.length > 0) &&
                                                                values.fieldList.map((item, index) => (
                                                                    <Row key={index} className="align-items-center">
                                                                        <Col xs="7" md="4">
                                                                            <Form.Group className="m-0">
                                                                                <Form.Label className="font-weight-bold-600 text-secondary">Nombre</Form.Label>
                                                                                <Field 
                                                                                    as="select"
                                                                                    className={`form-control input-form ${errors?.fieldList?.length > 0 && errors?.fieldList[index]?.fieldName?.id ? 'error' : ''}`}
                                                                                    name={`fieldList.${index}.fieldName.id`}
                                                                                >
                                                                                    <option value={""}>Seleccionar opción</option>
                                                                                    {
                                                                                        fieldOpt.map(field=>(
                                                                                            <option key={field.id} value={field.id}>{field.description}</option>
                                                                                        ))
                                                                                    }
                                                                                </Field>
                                                                                { (errors?.fieldList?.length > 0 && errors?.fieldList[index]?.fieldName?.id) && <div className="invalid-feedback d-block">{errors?.fieldList[index]?.fieldName?.id}</div> }
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col xs="2" md="2">
                                                                            <div className="form-check form-check-inline m-0">
                                                                                <Field
                                                                                    className="form-check-input"
                                                                                    name={`fieldList.${index}.visible`}
                                                                                    type="checkbox"
                                                                                />
                                                                                <label className="form-check-label">Visible</label>
                                                                            </div>
                                                                            { (errors?.fieldList?.length > 0 && errors?.fieldList[index]?.visible) && <div className="invalid-feedback d-block">{errors?.fieldList[index]?.visible}</div> }
                                                                        </Col>
                                                                        <Col xs="2" md="2">
                                                                            <div className="form-check form-check-inline m-0">
                                                                                <Field
                                                                                    className="form-check-input"
                                                                                    name={`fieldList.${index}.required`}
                                                                                    type="checkbox"
                                                                                />
                                                                                <label className="form-check-label">Requerido</label>
                                                                            </div>
                                                                        </Col>
                                                                        <Col xs="1" md="1">
                                                                            <Button type="button" variant="danger" size="sm" onClick={() => arrayHelper.remove(index)}>
                                                                                <FaTrash />
                                                                            </Button>
                                                                        </Col>
                                                                    </Row>
                                                                ))
                                                            }
                                                             <hr />
                                                             <Button type="button" variant="outline-primary" size="sm" onClick={() => arrayHelper.push({
                                                                fieldName: {id: ''},
                                                                visible: true,
                                                                required: false,
                                                                account: {
                                                                    id: id
                                                                }
                                                            })}>
                                                                <FaPlus className="mr-2"/>Agregar nuevo campo
                                                            </Button>
                                                        </div>
                                                    )}
                                                />
                                            </Col>
                                        </Row>                                        
                                    </Card.Body>
                                </Card>
                                

                                <Row className="grupoBotones">
                                <Col className="text-right">
                                    <Link to="/admin/cuentas" className="btn btn-danger cancelar-buttom">Cancelar</Link>{' '}
                                    <Button variant="outline-success" className="ok-buttom" type="submit">{`Aceptar`}</Button>{' '}
                                </Col>
                            </Row>
                            </Form>
                        )}</Formik>
                    </Col>
                </Row>
            </div></>
        }

        <ComponentModalErrorSever
            show={showModalServer}
            handleClose={handleCloseModalServer}
            error={errorServer}
        />
        <Modal show={showSuccess} onHide={handleCloseSuccess} centered className="border-0">
            <Modal.Body className="p-0">
                <div className="text-center position-relative overflow-hidden h-100p">
                    <Image src={iconRecheck} fluid className="img-recheck"/>
                    <h5 className="mb-0 text-app-success"> {t('solicitud_exitosa')} </h5>
                </div>                
            </Modal.Body>
        </Modal>
    </> )
}

export default withTranslation()(FieldsCuenta)